module.exports = __webpack_public_path__ + "img/BKFB2.22943a31.jpg";